export const getFlashingCellDurationViewItems = (flashingCell) => {
    return {
        name: 'Duration',
        values: [flashingCell.FlashDuration],
    };
};
